import { render } from "./CounterApp.vue?vue&type=template&id=955ea76e&scoped=true"
import script from "./CounterApp.vue?vue&type=script&lang=js"
export * from "./CounterApp.vue?vue&type=script&lang=js"

import "./CounterApp.vue?vue&type=style&index=0&id=955ea76e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-955ea76e"]])

export default __exports__